// extracted by mini-css-extract-plugin
export default {"wrapper":"evening-content_wrapper__tqgie","h2":"evening-content_h2__bTw85"};